(() => {
  const ADD_SELECTOR = '[data-upsell-add]';
  const SLIDER_SELECTOR = '[data-cart-upsell-slider]';
  const initializedTracks = new WeakSet();

  function getSliderElements(slider) {
    const track = slider.querySelector('[data-upsell-track]');
    const prevButton = slider.querySelector('[data-upsell-prev]');
    const nextButton = slider.querySelector('[data-upsell-next]');
    const cards = slider.querySelectorAll('[data-upsell-card]');

    return { track, prevButton, nextButton, cards };
  }

  function updateArrowState(slider) {
    const { track, prevButton, nextButton, cards } = getSliderElements(slider);
    if (!track || !prevButton || !nextButton) return;

    const hasOverflow = track.scrollWidth > track.clientWidth + 2;
    const atStart = track.scrollLeft <= 4;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

    if (!hasOverflow || cards.length <= 1) {
      prevButton.classList.add('is-hidden');
      nextButton.classList.add('is-hidden');
      prevButton.disabled = true;
      nextButton.disabled = true;
      return;
    }

    prevButton.disabled = atStart;
    nextButton.disabled = atEnd;
    prevButton.classList.toggle('is-hidden', atStart);
    nextButton.classList.toggle('is-hidden', atEnd);
  }

  function scrollSlider(slider, direction) {
    const { track } = getSliderElements(slider);
    if (!track) return;

    const firstCard = track.querySelector('[data-upsell-card]');
    const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth * 0.85;
    const computed = window.getComputedStyle(track);
    const gap = parseFloat(computed.columnGap || computed.gap || '0');
    const amount = (cardWidth + gap) * direction;

    track.scrollBy({ left: amount, behavior: 'smooth' });
  }

  function initializeSlider(slider) {
    const { track } = getSliderElements(slider);
    if (!track || initializedTracks.has(track)) return;

    initializedTracks.add(track);
    track.addEventListener('scroll', () => updateArrowState(slider), { passive: true });
    updateArrowState(slider);
  }

  function initializeAllSliders() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach((slider) => initializeSlider(slider));
  }

  async function addUpsellToCart(button) {
    if (!button || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    button.disabled = true;
    const originalLabel = button.textContent.trim();
    button.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        throw new Error('Unable to add upsell item');
      }

      const state = await response.json();
      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && state.sections) {
        // Empty -> non-empty transition: ensure drawer state class matches cart contents
        if (typeof state.item_count === 'number') {
          cartDrawer.classList.toggle('is-empty', state.item_count === 0);
        } else {
          cartDrawer.classList.remove('is-empty');
        }

        cartDrawer.renderContents({
          id: variantId,
          sections: state.sections,
        });
      }

      button.textContent = 'Added';
    } catch (error) {
      console.error('[CartUpsell] add failed:', error);
      button.disabled = false;
      button.textContent = originalLabel;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(ADD_SELECTOR);
    if (!button) return;

    event.preventDefault();
    addUpsellToCart(button);
  });

  document.addEventListener('click', (event) => {
    const prev = event.target.closest('[data-upsell-prev]');
    const next = event.target.closest('[data-upsell-next]');
    if (!prev && !next) return;

    const slider = event.target.closest(SLIDER_SELECTOR);
    if (!slider) return;

    event.preventDefault();
    scrollSlider(slider, next ? 1 : -1);

    // Update state after smooth scroll settles
    window.setTimeout(() => updateArrowState(slider), 260);
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(SLIDER_SELECTOR).forEach((slider) => updateArrowState(slider));
  });

  const observer = new MutationObserver(() => initializeAllSliders());
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllSliders, { once: true });
  } else {
    initializeAllSliders();
  }
})();
